import { EFileType } from '@/constant';
import { GetCommonInquiryBoardListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatCommonInquiryBoardDetail = (
	input: GetCommonInquiryBoardListResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input?.registDt),
		updateDt: formatDate(input?.updateDt),
		answerRegistDt: formatDate(input?.answerRegistDt),
		answerUpdateDt: formatDate(input?.answerUpdateDt),
		fileList: input?.files?.map((file) => ({
			...file,
			uid: file.fileId,
			fileName: file.name,
			fileType: EFileType.SERVER,
			size: file.fileSize,
		})),
		attachFileIds: (input?.files?.map((file) => file.id) || []) as number[],
		answerFileList: input?.answerFiles?.map((file) => ({
			...file,
			uid: file.fileId,
			fileType: EFileType.SERVER,
			size: file.fileSize,
		})),
		answerFileIds: (input?.answerFiles?.map((file) => file.id) ||
			[]) as number[],
	};
};

export const formatCommonInquiryBoardList = (
	input: GetCommonInquiryBoardListResponse['content']
) => {
	return map(input, formatCommonInquiryBoardDetail);
};
